const locale = {
	BACKTOLOGIN: 'Zurück zum Login',
	RESETMYPASSWORD: 'Passwort zurücksetzen',
	SENDRESETLINK: 'Zurücksetzung anfordern',
	FORGOTHEADERMESSAGE: 'Passwort vergessen?',
	FORGOTHEADERSUBMESSAGE: 'Kein Problem, setzen Sie Ihr Passwort einfach zurück.',
	RESETHEADERMESSAGE: 'Passwort zurücksetzen',
	RESETHEADERSUBMESSAGE: 'Gleich ist es geschafft.',
	CONTINUE: 'Weiter',
	COMPANYCODE: 'Firmenkürzel',
	COMPANY: 'Firma',
	USERNAME: 'Benutzername',
	NEWPASSWORD: 'Neues Passwort',
	REPEATNEWPASSWORD: 'Neues Passwort wiederholen',
	COMPANYREQUIRED: "Bitte geben Sie Ihr Firmenkürzel ein",
	USERNAMEREQUIRED: "Bitte geben Sie Ihren Benutzernamen ein",
	PASSWORDREQUIRED: "Bitte geben Sie ein neues Passwort ein",
	PASSWORDSMUSTMATCH: "Passwörter stimmen nicht überein",
	INVALIDINPUT: "Ihre Eingabe enthält ungültige Zeichen",
	SHORTINPUT: "Ihre Eingabe ist zu kurz",
	NOCOMPANYFOUND: "Es konnte keine Firma mit diesem Kürzel gefunden werden",
	RESETERROR: 'Ein unbekannter Fehler ist aufgetreten!',
	RESETWASSUCCESSFUL: 'Der Passwortreset wurde erfolgreich durchgeführt.',
	FORGOTSUCCESSFUL: 'Überprüfen Sie Ihr Postfach!',
	FORGOTSUCCESSFULSUB: 'Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passwortes gesendet. Klicken Sie bitte dort auf den Link um den Vorgang abzuschließen!',
	BACKTOMAIN: "Zurück zur Startseite",
	CHANGEHEADERMESSAGE: 'Passwort ändern',
	CHANGEHEADERSUBMESSAGE: 'Gleich ist es geschafft.',
	CHANGEMYPASSWORD: "Passwort jetzt ändern",
	OLDPASSWORD: "Aktuelles Passwort",
	OLDPASSWORDREQUIRED: "Bitte geben Sie ihr aktuelles Passwort ein",
	CHANGEWASSUCCESSFUL: 'Die Passwortänderung wurde erfolgreich durchgeführt.',
	CHIPINFOHEADERMESSAGE: "NFC Chip Info",
	WAITINGFORTAG: "Es wird auf einen Chip zum Scannen gewartet...",
	STARTNEWSCAN: "Neuen Scan starten",
	NFCNOTAVAILABLE: "NFC ist nicht verfügbar",
	NFCNOTACTIVATED: "NFC ist nicht aktiviert",
	NFCNOTSUPPORTED: "NFC wird auf diesem Gerät nicht unterstützt",
	NONFCCHIPFOUND: "Kein NFC Chip gefunden",
	NFCCHIPNOTFORMATTED: "NFC Chip nicht formatiert",
	NFCCHIPNOTSUPPORTED: "NFC Chip nicht unterstützt",
	NFCHIPDETECTED: "NFC Chip erkannt, bitte warten...",
	NFCCHIPISVALID: "NFC Chip ist gültig",
	NFCCHIPUPDATENOTSUPPORTED: "NFC Chipupdate auf diesem Gerät nicht unterstützt",
	NFCHIPRESETSUCCESSFULL: "NFC Chip Reset erfolgreich",
	NFCHIPUPDATESUCCESSFULL: "NFC Chip Update erfolgreich",
	NFCDIFFERENTCHIPDETECTED: "Anderer NFC Chip erkannt, Vorgang abgebrochen",
	NFCERROR: "NFC Fehler, Vorgang abgebrochen",
	WAITINGONCHIPFORFORMAT: "Warte auf NFC Chip {{chipid}} zum Formattieren",
	WAITINGONCHIPFORUPDATE: "Warte auf NFC Chip {{chipid}} zum aktualisieren",
	FORMATCHIP: "Formatieren",
	UPDATECHIP: "Neu beschreiben",
	NFCCHIPCOMPANYDATA: "Chip-Firmendaten",
	NFCCHIPUSERDATA: "Chip-Benutzeraten",
	NFCCHIPOTHERDATASAVED: "NFC Chip hat auch nicht erkannte Daten gespeichert!",
	REGISTEREDTO: "Registriert auf",
	CHIPNAME: "Chipname",
	DSGVO: "Datenschutz",
	AGB: "AGB",
	COPYRIGHT: "Copyright © Alpsware GmbH",
};

export default locale;
